export const locale = {
    lang: 'ar',
    data: {
        NAVIGATION_BOARDS: 'اللوحات',
        NAVIGATION_SESSIONS: 'الورشات',
        NAVIGATION_DOCUMENTS: 'الوثائق',
        NAVIGATION_DETAILS: 'التفاصيل',
    }
};
